import { type Common } from '../common.js';
import {
  type FlowStandardAnalyticEventCategoryBody,
  type FlowStandardAnalyticEventCategoryListQuery,
  type StandardAnalyticEventCategory,
} from '../models/flow/standardAnalyticEventCategory.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/standard-analytic-event-categories';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: FlowStandardAnalyticEventCategoryListQuery
  ): Promise<StandardAnalyticEventCategory[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<StandardAnalyticEventCategory> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: FlowStandardAnalyticEventCategoryBody
  ): Promise<StandardAnalyticEventCategory> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: FlowStandardAnalyticEventCategoryBody
  ): Promise<StandardAnalyticEventCategory> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.putJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    await this.common.deleteJSON(url);
  }
}
